module.exports = __webpack_public_path__ + "static/media/4-1.a74c4ca4.png";